import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Activity, LayoutDashboard, Search, LibraryBig, Bookmark, Gift } from "lucide-react";
import { useWatchlist } from "../../context/WatchlistContext";

export const Navbar = ({ onSearch }) => {
  const [scrolled, setScrolled] = useState(false);
  const { count } = useWatchlist();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-navbar"
      className={`sticky top-0 z-40 w-full border-b transition-[background-color,border-color] duration-300 ${
        scrolled
          ? "border-white/10 bg-slate-900/70 backdrop-blur-xl"
          : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 lg:px-10">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5">
          <img src="/logo.png" alt="Ticker Templates" className="h-9 w-auto" />
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          {["Marketplace", "Bestsellers", "Autopilot", "Pricing"].map((l) => (
            <a
              key={l}
              href={`#${l.toLowerCase()}`}
              data-testid={`nav-link-${l.toLowerCase()}`}
              className="text-sm text-slate-300 transition-colors duration-200 hover:text-white"
            >
              {l}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-search-btn"
            onClick={onSearch}
            className="hidden h-9 w-9 items-center justify-center border border-white/10 text-slate-300 transition-colors duration-200 hover:border-white/30 hover:text-white sm:flex"
          >
            <Search className="h-4 w-4" />
          </button>
          <Link
            to="/watchlist"
            data-testid="nav-watchlist-link"
            className="relative hidden h-9 items-center gap-2 border border-white/10 px-3.5 text-sm text-slate-300 transition-colors duration-200 hover:border-white/30 hover:text-white sm:flex"
          >
            <Bookmark className="h-4 w-4" /> Watchlist
            {count > 0 && (
              <span data-testid="watchlist-count" className="ml-0.5 flex h-4 min-w-4 items-center justify-center bg-emerald-500 px-1 font-mono text-[10px] font-bold text-slate-950">
                {count}
              </span>
            )}
          </Link>
          <Link
            to="/refer"
            data-testid="nav-refer-link"
            className="hidden items-center gap-2 border border-emerald-500/40 px-3.5 py-2 text-sm text-emerald-300 transition-colors duration-200 hover:border-emerald-400 hover:text-white sm:flex"
          >
            <Gift className="h-4 w-4" /> Refer &amp; Earn
          </Link>
          <Link
            to="/library"
            data-testid="nav-library-link"
            className="hidden items-center gap-2 border border-white/10 px-3.5 py-2 text-sm text-slate-300 transition-colors duration-200 hover:border-white/30 hover:text-white sm:flex"
          >
            <LibraryBig className="h-4 w-4" /> Library
          </Link>
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            className="hidden items-center gap-2 border border-white/10 px-3.5 py-2 text-sm text-slate-300 transition-colors duration-200 hover:border-white/30 hover:text-white sm:flex"
          >
            <LayoutDashboard className="h-4 w-4" /> Admin
          </Link>
          <a
            href="#marketplace"
            data-testid="nav-cta-btn"
            className="bg-emerald-500 px-4 py-2 text-sm font-semibold text-slate-900 transition-[background-color] duration-200 hover:bg-emerald-400"
          >
            Browse Templates
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
